import { getObjectColors } from '@/utils/objectColors';
import { objectColorKey } from '../assistantFormat';

interface Props {
  objectId?: string | null;
  objectName?: string | null;
  label?: string | null;
  size?: 'sm' | 'md';
}

/** Object chip: soft background, ink text, 6px dot in the object colour. */
export function ObjectTag({ objectId, objectName, label, size = 'sm' }: Props) {
  const { color, soft, ink } = getObjectColors(objectColorKey(objectId, objectName));
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-medium whitespace-nowrap max-w-full ${
        size === 'sm' ? 'text-[10.5px] px-1.5 py-0.5' : 'text-[11.5px] px-2 py-1'
      }`}
      style={{ background: soft, color: ink }}
    >
      <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: color }} />
      <span className="truncate">{label || objectName}</span>
    </span>
  );
}
